import { RouteConfig } from '../../routing/types'

const ROUTE: RouteConfig = {
  name: 'topics-view',
  path: (params: { topicSlug: string }) => `/topics/${params.topicSlug}`,
}

export default ROUTE
